<div class="content-card">
  <div class="wrapper header">
    <div class="inline-element">
      <h3 class="accent-color">{{titulo}}</h3>
    </div>

    <div class="inline-element header-right">
      @if (numberOfSelectedNodes > 0) {
        <mat-chip class="accent-color" (click)="unselectItens()">
          <button matChipRemove (click)="unselectItens()">
            <mat-icon class="accent-color">cancel</mat-icon>
          </button>
          {{numberOfSelectedNodes}} {{numberOfSelectedNodes === 1 ? "Item Selecionado" : "Itens Selecionados"}} (Soma:
          R$ {{somaValoresSelecionados | number : '1.2-2'}})
        </mat-chip>
      }
      <button mat-icon-button class="auto-multi-select" [class.accent-color]="!autoMultiSelect"
        [class.auto-multi-select-ativo]="autoMultiSelect" [attr.aria-pressed]="autoMultiSelect"
        pTooltip="Selecionar várias linhas só com cliques (sem precisar segurar Ctrl)" tooltipPosition="bottom"
        (click)="autoMultiSelect = !autoMultiSelect">
        <mat-icon>checklist</mat-icon>
      </button>
      <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>

      <button class="accent-color" mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu" xPosition="before">
        <button mat-menu-item class="inline-element" (click)="exibirTodosLancamentos()">
          <mat-icon class="accent-color">visibility</mat-icon>
          Exibir todos lançamentos
        </button>
        <button mat-menu-item class="inline-element" (click)="esconderLancamentosConciliados()">
          <mat-icon class="accent-color">visibility_off</mat-icon>
          Esconder conciliados
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="table-container">
    <app-lancamentos-table [lancamentosExibidos]="lancamentosExibidos" [ehTabelaPrincipal]="true"
      [cardEhBanco]="cardEhBanco" [modoEdicao]="modoEdicao" [autoMultiSelect]="autoMultiSelect"
      [conciliacaoId]="conciliacaoId" [(selectedRows)]="selectedRows">
    </app-lancamentos-table>
  </div>
</div>